import { useComplianceAccess } from '../../../hooks/useComplianceAccess';
import PicklistEditor from './PicklistEditor';

/**
 * Compliance → Settings: the dropdown lists on the contract form. The page is
 * granted to compliance managers (and IT/Developers); the backend lets only
 * compliance managers and global admins save edits.
 */
export default function ComplianceSettings() {
  // isManager is also true for global admins (isInGroups bypass).
  const { isManager: canEdit } = useComplianceAccess();

  return (
    <div className="h-full w-full p-6 pb-24">
      <div className="mb-4">
        <h1 className="text-2xl font-bold">Settings</h1>
        <p className="text-sm text-muted">
          The Department and Category choices on the contract form.
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        <PicklistEditor kind="departments" title="Departments" noun="department" canEdit={canEdit} />
        <PicklistEditor kind="categories" title="Categories" noun="category" canEdit={canEdit} />
      </div>
    </div>
  );
}
